import React, { Component } from 'react'
import { Grid, Box } from '@material-ui/core'
import VideoCardItem from './VideoCardItem'
import Slider from "react-slick";
import { withStyles } from '@material-ui/core/styles'
import useStyles from "./styles/CarouselSectionForSmallStyle"
import '../../Horizontal/styles/slick.css'

class CarouselSectionForSmall extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentSlide: 0,
    }
  }

  next(){
    // Moves the slider-component one 'card' to the right.
    this.slider.slickNext();
  }

  render() {
    const classes = this.props.classes
    const currentVideo = this.props.playlist[this.state.currentSlide]

    // The slider component's settings:
    const settings = {
      centerMode: true,
      arrows: false,
      focusOnSelect: true,
      centerPadding: '10px',
      slidesToShow: 1.2,
      slidesToScroll: 1,
      initialSlide: 0,
      infinite: false,
      swipe: true,
      speed: 500,
      beforeChange: (current, next) => {
        // We are using Math.ceil to set the current slide because the final slide
        // may get a fractional index.
        this.setState({currentSlide: Math.ceil(next)})
      },
    };
    return (
      <Grid
        container
        className={classes.miniCarousel}
      >
        <Grid
          item lg={12} md={12} sm={12}
        >
        {/* Slider is the 'container' for the video card items (the slides) */}
          <Slider ref={c => (this.slider = c)} {...settings}>
            {this.props.playlist.map((item, index) => {
              if (index === this.state.currentSlide) {
                /* If this is the main item: */
                return (
                  <Grid onClick={()=> this.props.onVideoClicked(index)} key={index}>
                    <VideoCardItem main={true}
                                   videoDetails={item}
                                   currentSlide={this.state.currentSlide}
                                   index={index}
                                   playListLength={this.props.playlist.length}
                    />
                    <Grid
                      style={{cursor: 'pointer'}}
                      container
                      className={classes.titlesContainer}
                      direction="column"
                      alignItems="flex-start"
                      justify="flex-start"
                    >
                      <Grid item>
                        <Box className={`${classes.mainTitle} section-carousel-item-title`}>
                          {currentVideo.title}
                        </Box>
                      </Grid>
                      <Grid
                        item
                      >
                        <Box className={`${classes.secondaryTitle} section-carousel-item-subtitle`}>
                          {currentVideo.description}
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                )
              } else {
                // this is not the main item:
                // (it will appear without titles or animation).
                return (
                  <Grid key={index}>
                    <VideoCardItem
                      main={false}
                      key={index}
                      index={index}
                      currentSlide={this.state.currentSlide}
                      videoDetails={item}
                      playListLength={this.props.playlist.length}
                    />
                  </Grid>
                )
              }
            }
            )}
          </Slider>
        </Grid>
      </Grid>
    )
  }
}

export default withStyles(useStyles)(CarouselSectionForSmall)
